<div class="container">
  <h3>Importante</h3>
  <span>Si no has recibido la clave dinámica:</span>
  <ul>
    <li class="pl-2 before:content-['•'] before:inline-block before:mr-1">
      Revisa si los datos de correo electrónico y número de celular son
      correctos.
    </li>
    <li class="pl-2 before:content-['•'] before:inline-block before:mr-1">
      Revisa en tu bandeja de correo SPAM.
    </li>
    <li class="pl-2 before:content-['•'] before:inline-block before:mr-1">
      Si ninguno de los datos corresponde, comunícate con tu ejecutivo.
    </li>
  </ul>
</div>
